import React from "react";
import { PROCESS } from "../mock/mock";
import useInView from "../hooks/useInView";

export default function Process() {
  const [ref, inView] = useInView();

  return (
    <section id="process" className="relative bg-[#0c1a2c] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-bold tracking-[0.2em] text-[#F5941E]">
            {PROCESS.kicker}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight leading-tight">
            {PROCESS.title}
            <br />
            <span className="text-slate-400">{PROCESS.subtitle}</span>
          </h2>
        </div>

        <div
          ref={ref}
          className="mt-16 grid md:grid-cols-3 gap-8 relative"
        >
          {/* connecting line */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#F5941E]/40 to-transparent" />

          {PROCESS.steps.map((step, i) => (
            <div
              key={step.n}
              className={`relative rounded-3xl border border-white/10 bg-white/[0.03] p-8 transition-all duration-700 hover:border-[#F5941E]/30 hover:-translate-y-1 ${
                inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#F5941E] text-2xl font-black text-white shadow-lg shadow-orange-900/30">
                {step.n}
              </div>
              <h3 className="mt-6 text-xl font-bold text-white">
                {step.title}
              </h3>
              <p className="mt-3 leading-relaxed text-slate-400">
                {step.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
